//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

const hasWellFormattedPrefix = (text: string, url: string) => {
  const index = text.indexOf(url);
  if (index - 1 >= 0) {
    return text.charAt(index - 1).trim().length === 0;
  }
  return true;
};

const hasWellFormattedSuffix = (text: string, url: string) => {
  const index = text.indexOf(url);
  if (index !== -1 && index + url.length < text.length) {
    return /^[\s.,;]*$/.test(text.charAt(index + url.length));
  }
  return true;
};

export const hasWellFormattedUrl = (text: string, url: string) =>
  text.includes(url) &&
  hasWellFormattedPrefix(text, url) &&
  hasWellFormattedSuffix(text, url);
